import { Component, OnDestroy } from '@angular/core';
import { AlertController, NavParams, ToastController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { formatNumber } from '@angular/common';
import { FormGroup, FormControl } from '@angular/forms';
import { User } from 'src/assets/data/interfaces/interfaces-service';
import { Storage } from '@ionic/storage-angular';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-cantidad-puja',
  templateUrl: './cantidad-puja.component.html',
  styleUrls: ['./cantidad-puja.component.scss'],
})
export class CantidadPujaComponent implements OnDestroy {
  especie;
  cantidad;

  unidad;
  precio;
  divisible;
  timerInterval;
  clientes;
  group = new FormGroup({
    peso: new FormControl(''),
    cliente: new FormControl('')
  });
  timer: any;

  user: User;

  // @ViewChild(MatSort, {static: true}) sort: MatSort;
  constructor(
    navParams: NavParams,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private apiService: ApiService,
    public storage: Storage,
  ) {
    this.storage.get("user").then(data => {
      this.user.username = data.username;
      this.user.userId = data.userId;
      this.user.clientes = data.clientes;
      this.user.roles = data.roles;
    });
    this.especie = navParams.get('especie');
    this.group.controls['peso'].setValue(formatNumber(navParams.get('cantidad'), "es-Es", "1.2-2"))
    //this.cantidad = navParams.get('cantidad');
    this.unidad = navParams.get('unidad');
    this.precio = navParams.get('precio');
    this.divisible = navParams.get('divisible');
    this.timer = navParams.get('timer');
    this.apiService.getclientes(this.user.userId).subscribe(data => {
      this.clientes = data
      this.group.controls['cliente'].setValue(this.clientes[0]['id'])
    })
    this.timerInterval = setInterval(() => {
      if (this.timer == 0) {
        clearInterval(this.timerInterval)
        try {
          this.alertCtrl.dismiss()
        } catch { }
        this.modalCtrl.dismiss({ dismissed: true, cantidad: 0, cliente: 0 });
      }
      this.timer--
    }, 1000)

  }
  ngOnDestroy(): void {
    clearInterval(this.timerInterval)
  }

  onFocus(event) {
    event.target.value = "";
  }
  formatNumber(n) {
    if (this.group.controls[n].value) {
      this.group.controls[n].setValue(formatNumber(parseFloat(this.group.controls[n].value.toString().replaceAll(" ", "").replaceAll(".", "").replaceAll(",", ".")), "es-Es", "1.2-2"))
    }

  }


  numberOnlyValidation(event: any) {
    const pattern = /[0-9.]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  confirmarCantidad(OK) {
    if (OK) {
      if (this.group.controls['cliente'].value != '') {
        if (this.cantidad > 0) {
          this.mostrarAlerta("Confirmar compra de: <br><span class='cant'>" + this.group.controls['peso'].value + " " + this.unidad + "</span> a <span class='cant'>" + this.precio + " €/" + this.unidad + "</span>");
        } else {
          this.mostrarToast("Cantidad no valida", 2000);
        }
      } else {
        this.mostrarToast("Introduzca Cliente", 2000);
      }

    } else {
      this.cantidad = 0;
      this.modalCtrl.dismiss({ dismissed: true, cantidad: 0, cliente: 0 });
    }
  }

  async mostrarAlerta(message) {
    let finalMessage = '<div class="alertImageContainer vertical"><ion-icon class="icon"  name="cart"></ion-icon><br><label class="mensaje">' + message + '</label></div>';

    const alert = await this.alertCtrl.create({
      cssClass: 'custom-alert-class',
      backdropDismiss: false,
      message: finalMessage,

      buttons: [{
        text: 'Cancelar',
        role: 'cancel',
        cssClass: "cancelarButton",
        handler: () => { this.dismissModal(false); alert.dismiss(); }
      }, {
        text: 'Confirmar',
        cssClass: "confirmarButton",
        handler: () => { this.dismissModal(true); alert.dismiss(); }
      }]
    });
    await alert.present();
  }

  async mostrarConfirmacion(message, type) {
    let finalMessage;
    if (type == 'confirmar') {
      finalMessage = '<div class="alertImageContainer"><img src="../../assets/img/confirmacion.png" class="alertImage"><br>' + message + '</div>';
    } else {
      finalMessage = '<div class="alertImageContainer"><img src="../../assets/img/error.png" class="alertImage"><br>' + message + '</div>';
    }
    const alert = await this.alertCtrl.create({
      cssClass: 'custom-alert-class',
      message: finalMessage,
      buttons: [{
        text: 'ok',
        cssClass: "okButton",
        handler: () => { this.dismissModal(true); alert.dismiss(); }
      }]
    });
    await alert.present();
  }

  async mostrarToast(message, time) {
    let toast = await this.toastCtrl.create({
      message: message,
      duration: time,
      position: 'top',
      cssClass: 'toast-scheme'
    });
    toast.present();
  }

  public dismissModal(exec) {
    if (exec) {
      if (this.group.controls['cliente'].value) {
        this.modalCtrl.dismiss({ dismissed: true, cantidad: this.group.controls['peso'].value, cliente: this.group.controls['cliente'].value });
      } else {
        this.modalCtrl.dismiss({ dismissed: true, cantidad: this.group.controls['peso'].value, cliente: 0 });
      }

    }
  }

}